import { useReportsContext } from '@/dashboards/Reports/hooks';
import { byteConverter } from '@analytical-alley/common';
import { Button } from '@analytical-alley/ui';
import { AiOutlineDownload, AiOutlineEye } from 'react-icons/ai';
import { Report } from './types';

interface Props {
    report: Report;
}

export const ReportItem = ({ report }: Props) => {
    const { fileName, fileSize, extension } = report;

    const { downloadReport, previewReport } = useReportsContext();

    const size = byteConverter(fileSize);
    const name = fileName.split('.').shift();

    return (
        <div className="flex justify-between glass shadow-lg rounded-xl">
            <div className="flex p-6 gap-2 divide-x-2 items-center">
                <div className="">{name}</div>
                <div className="pl-2">{extension.toUpperCase().slice(1)}</div>
                <div className="pl-2">{size}</div>
            </div>

            <div className="flex gap-2 p-6">
                <Button
                    size="xxs"
                    color="transparent"
                    className="p-2 rounded-full hover:glass border"
                    aria-label="Download report"
                    title="Download report"
                    onClick={() => downloadReport(report)}
                >
                    <AiOutlineDownload />
                </Button>
                <Button
                    size="xxs"
                    color="transparent"
                    className="p-2 rounded-full hover:glass border"
                    aria-label="Preview report"
                    title="Preview report"
                    onClick={() => previewReport(report)}
                >
                    <AiOutlineEye />
                </Button>
            </div>
        </div>
    );
};
